import React, { useEffect, useState } from "react";
import DemoInterestedSection from "../../Component/DemoInterestedSection";
import ProductsTabsSection from "./component/ProductsTabsSection";
import ProductsBannerSection from "./component/ProductsBannerSection";

function ProductsPage() {
  const [acfData, setAcfData] = useState(null);
  const onRefresh = async () => {
    try {
      const response = await fetch("https://www.lagunacreek.io/blog/wp-json/custom/v1/acf-data/products");

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const source = await response.json();
      const acf_fields = source?.acf_fields;
      setAcfData(acf_fields)
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  useEffect(() => {
    onRefresh()
  }, []);

  return (
    <>
      <ProductsBannerSection acfData={acfData} />
      <ProductsTabsSection acfData={acfData} />
      <DemoInterestedSection acfData={acfData} />
    </>
  );
}

export default ProductsPage;
